<template>
  <!-- Edit address -->
  <section class="section section--profile">
    <div class="container-lg">

      <template v-if="user.hasOwnProperty('addresses') && user.addresses.length > 0">
        <form v-for="address in user.addresses" class="form" method="post" @submit.prevent="submitForm">

          <div class="row">
            <div class="col-lg-9">
              <div class="section__header">
                <h2 class="section__title">
                  {{ in18['page_address_delivery'] }}
                </h2>
              </div>
              <div class="form__fieldset mb-0">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form__group form__group--md">
                      <input id="address" v-model="address.address" class="form-control" name="address" type="text">
                      <label class="form-label" for="address">
                        {{ in18['attribute_address'] }}
                      </label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group">
                      <div class="form-control  form-control--select">
                        <select v-model="address.country.id" name="country_id">
                          <option v-for="country in countries" :value="country.id">
                            {{ country.title }}
                          </option>
                        </select>
                      </div>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group">
                      <div class="form-control  form-control--select">
                        <select v-model="address.city.id" name="city">
                          <option v-for="city in cities" :value="city.id">
                            {{ city.title }}
                          </option>
                        </select>
                      </div>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group">
                      <div class="form-control  form-control--select">
                        <select v-model="address.region.id" name="region_id">
                          <option v-for="region in regions" :value="region.id">
                            {{ region.title }}
                          </option>
                        </select>
                      </div>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group">
                      <div class="form-control  form-control--select">
                        <select v-model="address.area.id" name="area_id">
                          <option v-for="area in areas" :value="area.id">
                            {{ area.title }}
                          </option>
                        </select>
                      </div>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form__group form__group--md">
                      <input id="village" v-model="address.village" class="form-control" name="village" type="text">
                      <label class="form-label" for="village">{{ in18['attribute_address_village'] }}</label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group form__group--md">
                      <input id="house_num" v-model="address.house_num" class="form-control" name="house_num"
                             type="text">
                      <label class="form-label" for="house_num">{{ in18['attribute_house_number'] }}</label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form__group form__group--md">
                      <input id="building_num" v-model="address.building_num" class="form-control" name="building_num"
                             type="text">
                      <label class="form-label" for="building_num">{{ in18['attribute_building_number'] }}</label>
                      <svg class="form-control-icon">
                        <use href="#form-location"></use>
                      </svg>
                    </div>
                  </div>
                </div><!-- /.row -->
              </div><!-- /.form__fieldset -->

              <div class="form__fieldset">
                <div class="form__group form__group--sm">
                  <div class="checkbox">
                    <input id="checkbox_11" class="checkbox__input" name="checkbox_11" type="checkbox">
                    <label class="checkbox__label"
                           for="checkbox_11">{{ in18['attribute_address_current_building_address'] }}</label>
                  </div>
                </div>

                <div class="form__group form__group--sm">
                  <div class="checkbox">
                    <input id="checkbox_12" class="checkbox__input" name="checkbox_12" type="checkbox">
                    <label class="checkbox__label" for="checkbox_12">{{
                        in18['attribute_address_current_delivery']
                      }}</label>
                  </div>
                </div>
              </div><!-- /.form__fieldset -->

              <button class="btn btn--md btn--green" type="submit">{{ in18['page_save'] }}</button>
              <button class="btn btn--md btn--primary-outline" type="button">{{ in18['page_cancel'] }}</button>

            </div><!-- /.col -->
          </div><!-- /.row -->
        </form>
      </template>
    </div><!-- /.container -->
  </section>

</template>
<script>

import ValidationError from './../../features/ValidationError.vue';

export default {
  name:       "ProfileAddress",
  components: {
    ValidationError,
  },
  props:      {
    user:             {
      type: Object
    },
    in18:             {
      type: Object
    },
    captcha_site_key: {
      type: String
    },
  },
  data() {
    return {
      countries: [],
      cities:    [],
      regions:   [],
      areas:     [],
    }
  },
  created() {
    axios.get('/api/countries').then((response) => {
      const data = response.data;
      this.countries = data.countries;
      this.cities = data.countries[0].cities;
      this.regions = data.countries[0].regions;
      this.fillAreas();
    });
  },
  methods: {
    submitForm() {

    },
    fillAreas() {
      this.areas = this.regions.find(region => region.id === this.address.region.id)?.areas || [];
    },
  }
}
</script>
